import { EnhancedKPIViewContainerProps } from './EnhancedKPIViewContainer'
import EnhancedKPIViewContainer from './EnhancedKPIViewContainerLazy'
export default EnhancedKPIViewContainer
export type { EnhancedKPIViewContainerProps }
